import Helmet from '../../components/Helmet';
import useLanguage from '../../hooks/useLanguage';
import React, { useContext, useEffect, useRef, useState } from 'react';
import '../Activity/index.scss';
import { getBanner, postList, getTypes } from './service';
import Context from '../../container';
import MainTitle from '../../components/Common/main-title';
import Slider, { Settings } from 'react-slick';
import { isValid, oss } from '../../scripts/utils';
import map from 'lodash/map';
import { isDark } from '../../scripts/color-extractor/utils';
import { getColorByUrl } from '../../scripts/color-extractor/index';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import CircleButton from '../../components/Common/circle-button';
import { CursorPagination } from '../../components/Common/cursor-pagination';
import { dateFormatter, enDateFormatter, fieldTranslation } from '../../components/constants';
import DownOne from '../../components/IconWrapper/down-one';
import { DatePicker, Select, Input } from 'antd';
import { SearchOutlined, UnorderedListOutlined, AppstoreFilled } from '@ant-design/icons';
import cn from 'classnames';
import zh from 'antd/locale/zh_CN';
import en from 'antd/locale/en_US';
import { divideData } from '../../components/About/news';
import Divider from '../../components/Common/divider';
import Pagination from '../../components/Common/pagination';
import { getTitle } from '../../components/services';
import usePlatform from '../../hooks/usePlatform';
import MobileDatePicker from '../Activity/mobile-date-picker';
import { InfiniteScroll } from 'antd-mobile'
import LiveButton from '../Activity/live-button'

interface MediaSearch {
  resourceTypes?: string[];
  titleContent?: string;
  startDate?: number;
  endDate?: number;
}
export interface SearchParams {
  site?: {
    id: number;
  };
  multimediaResource?: MediaSearch;
  pageNo?: number;
  pageSize?: number;
}

const Media = () => {
  const { i18n } = useLanguage();
  const { currentSite = {}, lang } = useContext(Context);
  const { isMobile } = usePlatform();
  const [headerInfo, setHeaderInfo] = useState({
    title: '',
    desc: ''
  });
  const [displayType, setDisplayType] = useState<'card' | 'list'>('card');
  const [resourceTypes, setTypes] = useState<string[]>([])
  const [pageInfo, setPageInfo] = useState({
    total: 0,
    pageNo: 1,
    pageSize: 10
  });
  const [mediaSearch, setMediaSearch] = useState<MediaSearch>({});
  const [data, setData] = useState<any[]>([]);

  const [mobileData, setMobileData] = useState<any[]>([])
  const [hasMore, setHasMore] = useState(true)
  const pageNoMobileRef = useRef(1)
  const isMountRef = useRef(true)

  async function loadMore() {
    const res = await postList({
      pageNo: pageNoMobileRef.current,
      pageSize: 10,
      multimediaResource: mediaSearch,
      site: { id: currentSite.id },
    })
    const {total, data} = res as unknown as { total: number; data: any[] }
    pageNoMobileRef.current ++
    const finalData = [...mobileData, ...data]
    setMobileData(finalData)
    setHasMore(finalData.length < total)
  }

  const PAGE_COLUMN = isMobile ? 1 : 2;

  const list = divideData(data, PAGE_COLUMN);
  const mobileList = divideData(mobileData, PAGE_COLUMN);

  const handlePageChange = (page: number, size: number) => {
    setPageInfo((info) => ({
      ...info,
      pageNo: page,
      pageSize: size
    }));
  };

  const handleDateChange = (d: any) => {
    if (d === null || d === undefined) {
      setMediaSearch((s) => ({
        ...s,
        startDate: undefined,
        endDate: undefined
      }));
    } else {
      setMediaSearch((s) => ({
        ...s,
        startDate: d[0]?.startOf('day').valueOf(),
        endDate: d[1]?.endOf('day').valueOf()
      }));
    }
  };

  useEffect(() => {
    if (!isMountRef.current && isMobile) {
      pageNoMobileRef.current = 1
      setMobileData([])
      setHasMore(true)
    } else {
      isMountRef.current = false
    }
  }, [mediaSearch])

  useEffect(() => {
    if (currentSite.id) {
      getTitle({ type: 'MULTIMEDIA_RESOURCE', site: { id: currentSite.id } }).then((res) => {
        const { title, desc } = res;
        setHeaderInfo({
          title,
          desc
        });
      });
      getTypes().then((res: any) => {
        setTypes(res)
      })
    }
  }, [currentSite.id]);

  useEffect(() => {
    if (currentSite.id && !isMobile ) {
      postList({
        site: { id: currentSite.id },
        pageNo: pageInfo.pageNo,
        pageSize: pageInfo.pageSize,
        multimediaResource: mediaSearch
      }).then((res) => {
        const { data, total } = res as unknown as { total: number; data: any[] };
        setPageInfo((s) => ({ ...s, total }));
        setData(data);
      });
    }
  }, [mediaSearch, currentSite.id, pageInfo.pageNo, pageInfo.pageSize, isMobile]);

  const MediaItem = ({items, hideDivider}: {hideDivider?: boolean;items: any[]}) => {
    return (
        <div className="activity-list-row">
        <div className="activity-list-row-item-wrapper">
          {map(items, (item, i) => {
            return (
              <Link
                className={cn('activity-list-row-item', {
                  'activity-list-row-item-small': displayType === 'list'
                })}
                to={`/media/${item.id}`}
                key={item.id}
              >
                {item.liveAddress && <LiveButton {...item} />}
                <img src={oss(item.coverMaterial?.files[0]?.url, 434, 244)} alt={item.titleContent} />
                <div>
                  <div className="item-intro line-clamp-1">{item.titleContent}</div>
                  <div className="item-time">{dayjs(item.createdAt).format('YYYY年MM月DD日')}</div>
                </div>
              </Link>
            );
          })}
        </div>
        {
          hideDivider ? null : <Divider />
        }
      </div>
    )
  }

  return (
    <React.Fragment>
      <Helmet title="端点-Terminus-数字化转型-商业软件" description={''} />
      <div className="activity-wrapper">
        <MainTitle
          className="activity-title hidden-in-mobile"
          main={headerInfo.title}
          sub={headerInfo.desc}
          size={'xl'}
        />
        <ActivityCarousel />
        <div className="activity-filter">
          <div className="activity-filter-selector">
            <DatePicker.RangePicker
              locale={lang === 'cn' ? zh.DatePicker : en.DatePicker}
              value={
                mediaSearch?.startDate
                  ? [dayjs(mediaSearch?.startDate), dayjs(mediaSearch?.endDate)]
                  : undefined
              }
              allowClear
              onChange={handleDateChange}
              className="filter-picker hidden-in-mobile"
              placeholder={[i18n(fieldTranslation, '开始时间'), i18n(fieldTranslation, '结束时间')]}
            />
            <MobileDatePicker
              className="hidden-in-pc"
              value={
                mediaSearch?.startDate
                  ? [dayjs(mediaSearch?.startDate), dayjs(mediaSearch?.endDate)]
                  : undefined
              }
              onChange={handleDateChange}
              placeholder={i18n(fieldTranslation, '时间范围')}
            />
            <Select
              className="filter-select"
              options={map(resourceTypes, (type) => ({
                label: type,
                value: type
              }))}
              allowClear
              maxTagCount="responsive"
              value={mediaSearch.resourceTypes}
              onChange={(v) => setMediaSearch((s) => ({ ...s, resourceTypes: v }))}
              showSearch={false}
              bordered={false}
              showArrow={true}
              mode="multiple"
              suffixIcon={<DownOne size={14} />}
              placeholder={i18n(fieldTranslation, '所有类型')}
            />
          </div>
          <div>
            <span className="list-type-switch hidden-in-mobile">
              <span onClick={() => setDisplayType('card')} className={cn({ 'icon-active': displayType === 'card' })}>
                <AppstoreFilled size={16} />
              </span>
              <span onClick={() => setDisplayType('list')} className={cn({ 'icon-active': displayType === 'list' })}>
                <UnorderedListOutlined size={16} />
              </span>
            </span>
            <Input
              allowClear
              prefix={<SearchOutlined style={{ color: '#676A76' }} />}
              className="filter-input"
              placeholder={i18n(fieldTranslation, '请输入关键字')}
              value={mediaSearch.titleContent}
              onChange={(ev) => setMediaSearch((s) => ({ ...s, titleContent: ev.target.value }))}
            />
          </div>
        </div>
        <div className='hidden-in-mobile'>
          <div className="activity-list">
            {map(list, (items, idx) => {
              return <MediaItem hideDivider={pageInfo.total < pageInfo.pageSize && list.length === idx + 1} items={items} key={idx} />
            })}
            <Pagination
              onChange={handlePageChange}
              total={pageInfo.total}
              pageSize={pageInfo.pageSize}
              current={pageInfo.pageNo}
              hideOnSinglePage={true}
            />
          </div>
        </div>
        <div className='hidden-in-pc'>
          <div className="activity-list">
            {map(mobileList, (items, idx) => {
              return (
                <MediaItem hideDivider={list.length === idx + 1} items={items} key={idx} />
              );
            })}
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const ActivityCarousel = () => {
  const sliderRef = useRef<Slider | null>(null);
  const [imagesData, setImagesData] = useState<string[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [theme, setTheme] = useState<'dark' | 'light' | undefined>(undefined);
  const context = useContext(Context);
  const { currentSite = {}, lang } = context;
  const [activeIndex, setActiveIndex] = useState(0);
  const isShowController = data.length > 1;
  const { isMobile } = usePlatform();
  const handleGoto = (index: number) => {
    sliderRef.current?.slickGoTo(index);
  };
  const handlePrev = () => {
    sliderRef.current?.slickPrev();
  };
  const handleNext = () => {
    sliderRef.current?.slickNext();
  };
  useEffect(() => {
    if (isValid(currentSite.id)) {
      getBanner(currentSite.id).then((res) => {
        const result = res as any;
        setData(result);
        Promise.all(
          map(result, (d: any) => {
            return d.coverMaterial?.files[0]?.url;
          })
        ).then((res) => {
          setImagesData(res as string[]);
        });
      });
    }
  }, [currentSite.id]);

  useEffect(() => {
    if (!isMobile && imagesData[activeIndex]) {
      getColorByUrl(imagesData[activeIndex], {
        clip: {
          offsetY: 300
        }
      }).then((c) => {
        setTheme(isDark(c) ? 'dark' : 'light');
      });
    }
  }, [activeIndex, imagesData, isMobile]);

  const settings: Settings = {
    fade: true,
    autoplay:  data.length > 1,
    autoplaySpeed: 8000,
    infinite: true,
    arrows: false,
    adaptiveHeight: false,
    beforeChange: (current, next) => setActiveIndex(next)
  };

  return (
    <div className={cn("activity-carousel", {'activity-carousel-mb': isShowController})}>
      {data.length > 0 && <Slider ref={sliderRef} {...settings} className="activity-carousel-slider">
        {map(data, (d, contentIndex) => {
          return (
            <div key={contentIndex}>
              <Link to={`/media/${d.id}`}>
                {d.liveAddress && <LiveButton {...d}/>}
                <div
                  className="activity-carousel-content img-background"
                  style={{ backgroundImage: `url("${oss(imagesData[contentIndex], 2000)}")` }}
                ></div>
              </Link>
            </div>
          );
        })}
      </Slider>}
     {data.length > 0 && <div className="activity-carousel-desc">
        <MainTitle
          size="lg"
          position="left"
          main={data[activeIndex]?.titleContent}
          theme={theme}
          subStyle={{ height: 20 }}
          sub={dayjs(data[activeIndex]?.createdAt).format(lang === 'cn' ? dateFormatter : enDateFormatter)}
        />
        {isShowController ? (
          <CursorPagination
            className="activity-carousel-pagination"
            onItemClick={handleGoto}
            count={data.length}
            activeIndex={activeIndex}
          />
        ) : null}
      </div>}
      {isShowController ? (
        <>
          <CircleButton className="circle-left" onClick={handlePrev} type="prev" />
          <CircleButton className="circle-right" onClick={handleNext} type="next" />
        </>
      ) : null}
    </div>
  );
};

export default Media;
